module.exports = __webpack_public_path__ + "img/b7.abd9fc4a.png";